// utils/validation/noPhoneNumberDetected.ts

export function isPhoneNumberDetected(value?: string): boolean {
  if (!value) return true;

  // Pattern simple pour détecter des numéros comme :
  // - 0601020304
  // - +33 6 01 02 03 04
  // - 06.01.02.03.04
  // - 06-01-02-03-04
  // - (06) 01 02 03 04
  const phonePattern = /(\+?\d{1,3}[\s.-]?)?(\(?\d{2,4}\)?[\s.-]?)?\d{2,4}[\s.-]?\d{2,4}[\s.-]?\d{2,4}/g;

  return !phonePattern.test(value);
}
